/**
 * Goes through the product's pricing and gets a min and max to display on collection pages.
 * @param products
 */
export const getPriceRange = ({ products }) => {
  let min;
  let max;
  const sskMinPrices = (products || [])
    .map((product) => product?.identifiers?.isSuperSku && product?.info?.sskMin)
    .filter((price) => !!price);
  const sskMaxPrices = (products || [])
    .map((product) => product?.identifiers?.isSuperSku && product?.info?.sskMax)
    .filter((price) => !!price);
  if (sskMinPrices.length && sskMaxPrices.length) {
    min = Math.min(...sskMinPrices).toFixed(2);
    max = Math.max(...sskMaxPrices).toFixed(2);
  } else {
    const prices = (products || [])
      .map((product) => product?.pricing?.value)
      .filter((price) => !!price);
    if (!prices.length) {
      return {};
    }
    min = Math.min(...prices).toFixed(2);
    max = Math.max(...prices).toFixed(2);
  }
  return { min, max };
};

export const convertStrHyphenLowercase = (data) => {
  return data
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/[^a-z0-9-]+/gi, '') // Remove all non-alphanumeric characters
    .toLowerCase(); // Standardize casing
};

export const constants = {
  FABRIC_SAMPLES: '/p/Plantation-Patterns-3-in-x-3-in-CYOC-Fabric-Swatch-in-Graphite-SWATCH-0104293/311792177',
  RETURN_POLICY: '/c/Return_Policy',
  LIST_VIEW: 'List View Template',
  GROUPED_VIEW: 'Grouped View',
  GROUPED_LIST_VIEW: 'Grouped List View',
  INTEGRATED_BRAND: 'Integrated Brand Template',
  SIZE_AND_FIT_BRANDS: [
    'cstudio home',
    'cstudio',
    'the company store'
  ],
  FABRIC_SWATCHES: {
    CushionGuard: [
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/f6/f64a4964-9694-4acf-874e-20535b6aa244_35.jpg',
        label: 'Chili'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/f5/f577e258-e85d-420a-b74e-57fb9417567a_35.jpg',
        label: 'Sky '
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/6d/6d69193a-4ea2-4d3d-b9e9-a953a29a8e6e_35.jpg',
        label: 'Putty '
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/28/2887b166-b09e-4758-bfb0-796fb47dec2f_35.jpg',
        label: 'Charleston'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/5e/5e964e4e-a32c-407e-a71c-2c751da08265_35.jpg',
        label: 'Chalk'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/c7/c78af5e8-0d59-44aa-ba40-617a550ec03c_35.jpg',
        label: 'Quarry Red'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/d5/d5b3732e-2cb4-4c48-aaa6-8ca9a62f0d28_35.jpg',
        label: 'Midnight'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/63/6312e6d6-f1a3-4d9f-9a7a-69d8b91e1566_35.jpg',
        label: 'Graphite'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/6d/6d87af56-2413-426c-bd34-fd449247a4f9_35.jpg',
        label: 'Steel Blue'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/2a/2a7c9bc1-b506-47f4-90aa-0ae5e8078808_35.jpg',
        label: 'Midnight Trellis'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/37/378e3c16-9064-41fb-a00a-1d93bb58edc8_35.jpg',
        label: 'Toffee Solid'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/ed/ed0cda78-e831-446c-993d-c7550a7ff941_35.jpg',
        label: 'Seaglass'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/2a/2a0110ad-bb44-486d-a952-a4b8242a3699_35.jpg',
        label: 'Toffee Trellis'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/66/663baa9f-5a4f-4695-a56c-76fdaff2ad01_35.jpg',
        label: 'Stone Gray'
      }
    ],
    Sunbrella: [
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/32/329c333c-a147-49d9-b6fe-f558fa6c3108_35.jpg',
        label: 'Peacock'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/4f/4fbf5ae5-9231-4f70-a2f8-1dda8b3449af_35.jpg',
        label: 'Denim'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/bc/bcd36521-715d-4bf5-94bd-b541eb23a131_35.jpg',
        label: 'Henna'
      },
      {
        swatchImageURL:
          '//images.thdstatic.com/catalog/swatchImages/35/63/63238858-cf88-4805-96d8-a7c89d9cd30f_35.jpg',
        label: 'Beige'
      }
    ]
  }
};

export const getURLFormat = (str = '') => {
  return str.trim().toLowerCase().replace(' ', '-');
};

export const getQuickLinks = ({ metadata }) => {
  const { room, style } = metadata || {};
  if (!room?.length) {
    return [];
  }
  const roomLink = `/room/${getURLFormat(room[0])}`;
  const quickLinks = (style || []).map((styleName) => {
    const link = `${roomLink}/${getURLFormat(styleName)}`;
    return {
      label: styleName,
      link
    };
  });
  quickLinks.unshift({ label: room[0], link: roomLink });
  return quickLinks;
};

export const getSpaceCollectionBreadCrumb = ({ room }) => {
  const breadCrumbs = [
    { url: '/room/', label: 'Shop by Room' }
  ];
  if (room?.length) {
    const url = `/room/${getURLFormat(room[0])}`;
    breadCrumbs.push({
      url,
      label: room[0]
    });
  }
  return breadCrumbs;
};

// full image path will be available as part of data when grapQl is ready
// TODO: remove this fn when using graphql on space collection
export const getSpaceCollectionImagePath = (hosts, path, size = '1024x682') => {
  const basePath = (/edge-pr/g.test(hosts.api))
    ? 'https://images.thdstatic.com/lifestyleimages/'
    : 'https://storage.googleapis.com/hd-digitaldecor-dev-lifestyleimages/lifestyleimages/';
  return `${basePath}${size}/${path}`;
};

export const collectionQueryOption = ({ options, queryName }) => {
  const isSuperSkuProductQuery = queryName === 'product' && !options.ssr;
  if (isSuperSkuProductQuery || ['mediaPriceInventory', 'metadata'].includes(queryName)) {
    return {
      ...options,
      fetchPolicy: 'cache-first'
    };
  }
  return options;
};

export const cleanHtml = (desc) => {
  const html = desc?.replace(/<lt\/>/g, '<').replace(/<gt\/>/g, '>') || desc;
  return {
    __html: html
  };
};

export const skipFn = (opts, { isClientResolved }) => {
  const { skip, queryName, attributes } = opts;
  const isResolved = isClientResolved({ queryName: 'collection' });
  if (queryName !== 'product') {
    return skip;
  }

  if (attributes.product.fulfillment || attributes.product.badges || attributes.product.pricing) {
    if (!isResolved) {
      return true;
    }
  }

  return false;
};

export const getCollectionRatingsStats = ({ products }) => {
  return products.reduce(
    (
      previousStats,
      currentProduct
    ) => {
      const { reviews = {} } = currentProduct;
      const { ratingsReviews = {} } = reviews;
      const { averageRating = 0, totalReviews = 0 } = ratingsReviews;

      return {
        collectionRating: previousStats.collectionRating + (averageRating * Number(totalReviews)),
        collectionRatingReviewCount: previousStats.collectionRatingReviewCount + Number(totalReviews)
      };
    }, {
      collectionRating: 0,
      collectionRatingReviewCount: 0
    }
  );
};

export const curationSkipFn = (opts, { isClientResolved }) => {
  const { skip, queryName, attributes } = opts;
  const isResolved = isClientResolved({ queryName: 'curation' });
  if (queryName !== 'product') {
    return skip;
  }

  return attributes.product.fulfillment && !isResolved;
};